<template>
  <div>
    <div class="mb-4">
      <div class="header orange">ข้อมูลการจอง</div>
      <span>* ข้อมูลสำคัญกรุณาระบุ</span>
    </div>
    <div>
      <div class="mb-4 info">
        <div class="title-info">ข้อมูลส่วนตัว</div>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12  detail">
            <span>ชื่อ*</span
            ><el-input
              :value="value.firstName"
              @input="handleChangeValue('firstName', $event)"
            ></el-input>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
            <span>นามสกุล*</span
            ><el-input
              :value="value.lastName"
              @input="handleChangeValue('lastName', $event)"
            ></el-input>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
            <span>ชื่อบริษัท (optional)</span
            ><el-input
              :value="value.companyName"
              @input="handleChangeValue('companyName', $event)"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="mb-4 info">
        <div class="title-info">ที่อยู่</div>
        <div class="test">
          <address-auto-fill-selector
            v-model="addressForm"
          ></address-auto-fill-selector>
        </div>
      </div>
      <div class="mb-4 info">
        <div class="title-info">ข้อมูลบัญชี</div>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
            <span>อีเมล*</span
            ><el-input
              :value="value.email"
              @input="handleChangeValue('email', $event)"
            ></el-input>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
            <span>เบอร์โทรศัพท์*</span
            ><el-input
              :value="value.phoneNumber"
              type="text"
              @input="handleChangeValue('phoneNumber', $event)"
            ></el-input>
          </div>
          <!-- <div class="col-12 detail">
            ฉันยอมรับ ข้อกำหนดและเงื่อนไข และ นโยบายความเป็นส่วนตัว
            ในการสมัครสมาชิกของ  CC Conferance
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import AddressAutoFillSelector from "@/lib/components/AddressAutoFillSelector";

export default {
  components: {
    "el-input": Input,
    "address-auto-fill-selector": AddressAutoFillSelector,
  },
  props: ["value"],
  data() {
    return {
      addressForm: {},
      isSubmitFrom: false,
    };
  },
  methods: {
    handleChangeValue(key, value) {
      let newValue = value;

      const params = {
        ...this.value,
        [key]: newValue,
      };

      this.$emit("input", params);
    },
  },
  watch: {
    addressForm(newValue) {
      this.$emit("input", { ...this.value, addressForm: newValue });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.title-info {
  font-size: $font-20;
}

.info {
  border-bottom: 1px solid $color-light-gray-1;
  padding-bottom: 20px;
}

span {
  font-size: $font-14;
}

.header {
  font-size: $font-24;
  font-weight: bold;
}

.header,
.orange {
  color: $color-orange;
}

.detail {
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingFillPersonalDetail.vue